<template>
  <div class="reserveManager section" id="reserveManager">
    <h1 class="pagetitle">限定配信予約管理</h1>
    <div class="header reserveManager__columns">
      <p class="header__column left">予約日時</p>
      <p class="header__column center">キャスト名</p>
      <p class="header__column right">予約キャンセル</p>
    </div>
    <div class="reserve reserveManager__columns" v-for="(reserve, index) in dispReserveList[nowIndex]" :key="index" @click="move(reserve)">
      <p class="reserve__column__left left">{{format(reserve.startAt)}}</p>
      <p class="reserve__column__center center">{{reserve.castName}}</p>
      <div class="reserve__column__right right">
        <b-button v-if="!reserve.expired" class="button parent_event_cancel is-hidden-touch" label="キャンセル" @click="cancel(reserve)"/>
        <b-button v-if="!reserve.expired" class="button parent_event_cancel is-hidden-desktop" label="×" @click="cancel(reserve)"/>
      </div>
    </div>
    <div class="paging" v-if="dispReserveList.length > 1">
      <button class="paging__page__arrow" :disabled="nowIndex <= 0" @click="pageChanege(nowIndex - 1)">&lt;</button>
      <button class="paging__page" v-for="i in dispReserveList.length" :key="i" @click="pageChanege(i - 1)" :disabled="nowIndex == i - 1">{{ i }}</button>
      <button class="paging__page__arrow" :disabled="nowIndex + 1 >= dispReserveList.length" @click="pageChanege(nowIndex + 1)">&gt;</button>
    </div>
  </div>
</template>

<script>
import * as reserveServices from '@/services/reserveServices';
import * as liveServices from '@/services/liveServices';
import * as DateTime from '@/utils/date';
import * as modal from '@/utils/modal';
import { auth } from '@/plugins/firebase';
import { analyticsLog } from '@/utils/analytics';

const MAX_ROW = 10;

export default {
  name: 'ReserveManager',
  data() {
    return {
      reserveList: [],
      dispReserveList: [],
      nowIndex: 0,
      user: null,
      casts: {}
    };
  },
  async created() {
    this.user = auth.currentUser;
    await this.load();
    document.querySelectorAll(".parent_event_cancel").forEach(elem => {
      elem.addEventListener("click", event => {
        event.stopPropagation();
      });
    });
  },
  methods: {
    async load() {
      this.reserveList = await reserveServices.getReserveByUserId(this.user.uid);
      this.reserveList.sort((item1, item2) => { return item2.startAt - item1.startAt; });
      let criterionDate = (await DateTime.serverDate()).toJSDate();
      criterionDate.setHours(criterionDate.getHours() + 24);

      for (let item of this.reserveList) {
        let cast = await this.findCast(item.liveId);
        item["castName"] = cast ? cast.nickname : "";
        item["castId"] = cast ? cast.id : "";
        item["expired"] = criterionDate >= item.startAt;
      }

      let result = [];
      var i = 0;
      for (i = 0; i < this.reserveList.length; i = i + MAX_ROW) {
        result.push(this.reserveList.slice(i, i + MAX_ROW));
      }

      this.dispReserveList = result;
      this.nowIndex = 0;
    },
    async findCast(liveId) {
      if (this.casts[liveId]) {
        return this.casts[liveId];
      }

      let live = await liveServices.getUpComingLiveByLiveId(liveId);
      if (!live || !live.performerDocRef) {
        live = await liveServices.getRecentLiveByLiveId(liveId);
      }
      if (!live || !live.performerDocRef) {
        return null;
      }
      const livePerformerSnapshot = await live.performerDocRef.get();
      const performerDoc = livePerformerSnapshot.data();
      performerDoc["id"] = live.performerDocRef.id;

      this.casts[liveId] = performerDoc;
      return performerDoc;
    },
    pageChanege(idx) {
      this.nowIndex = idx;
    },
    format(date) {
      return DateTime.formatJSDate('yyyy/MM/dd HH:mm', date);
    },
    async cancel(reserve) {
      modal.confirm(this, "限定配信予約キャンセル",
        `予約をキャンセルします。<br/>※ゴールドは消費されません`,
        null, async () => {
          await reserveServices.cancel(reserve);
          analyticsLog('限定配信予約キャンセル完了【動作完了】', {'キャストID': reserve.castId});
          await this.load();
        }
      );
    },
    async move(reserve) {
      let type = await liveServices.getRecentLiveByLiveId(reserve.liveId) ? "recentLive" : "upComingLive";
      this.$router.push(`/live/streaming/${reserve.liveId}?type=${type}`);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../assets/scss/reserve-manager.scss';
</style>
